export const solidGeochemicalFilesMock = [
    {
        id: 'test-id',
        fileName: 'GEOCHEM1.json',
        associatedSampleIDs: 'S12312313',
        vendor: 'ALC',
        uploadDate: 'March 5, 2022',
    },
]
